export const ACCOUNT_OPERATION = {
    PAUSE: 'pause',
    RENEW: 'renew'
} as const;

// Helper types
type RouterObjectValue<T> = T[keyof T] | null

export type AccountOperationValue = RouterObjectValue<typeof ACCOUNT_OPERATION>
